module.exports = __webpack_public_path__ + "f22d58bca6df5d1c98d07e4cdaf5d61c.mp3";